import {
    House,         // Home
    Person,        // User Management
    ShieldLock,    // Permission Roles
    GeoAlt,        // Locations (or MapPin)
    Buildings,     // Hierarchy / Organizations
    CloudUpload, // Import / Export
} from "react-bootstrap-icons";

export const iconMapper = {
    "house": House,                // Home
    "buildings": Buildings,        // Manage Locations / Hierarchy
    "import-export": CloudUpload, // Import / Export
    "shieldLock": ShieldLock,     // Permission Roles
    "person": Person,          // User Management / Support
    "location": GeoAlt
};

// Graceful fallback if unknown icon
export function getBootstrapIcon(iconString = "") {
    const baseKey = iconString.split(" ").slice(0, 2).join(" "); // "ni ni-building"
    return iconMapper[baseKey] || House;
}
